import React, {FC} from "react";
import {Avatar, Box} from "@material-ui/core";

import RichText from "view/components/RichText";
import {
  IDefaultEmailTemplate,
  IOrganiser,
  IShow,
} from "@evennt-tech/api-v2-core";
import useStyles from "./styles";

type Props = {
  show: IShow;
  emailTemplate: IDefaultEmailTemplate;
};

const TaskIsCloseDueEmailBody: FC<Props> = ({emailTemplate, show}) => {
  const classes = useStyles();

  return (
    <Box display="flex" flexDirection="column">
      <Box className={classes.logosContainer}>
        <Avatar
          className={classes.logo}
          variant="square"
          src={show.logoFile?.url || ""}
        />
      </Box>
      <Box className={classes.greeting}>{emailTemplate.greeting}</Box>
      <Box className={classes.emailBody}>
        <RichText
          className={classes.emailText}
          content={emailTemplate.emailText}
        />
        <RichText
          className={classes.taskItem}
          content={emailTemplate.taskText}
        />
        <RichText
          className={classes.taskItem}
          content={emailTemplate.taskText}
        />
        <RichText
          className={classes.taskItem}
          content={emailTemplate.taskText}
        />
      </Box>
      <Box className={classes.submitButton}>{emailTemplate.buttonText}</Box>
    </Box>
  );
};

export default TaskIsCloseDueEmailBody;
